import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { UnidataTable } from '~/components';
import { number } from '~/helpers';

import { recordFiltering } from '~/store/modules/operacaoliberacaoremotaconsulta/actions';

import { format, setHours, setMinutes, setSeconds, parseISO } from 'date-fns';

import { FormatarCodigoLiberacao } from '~/helpers';

function OperacaoLiberacaoRemotaConsultaList() {
  const operacaoliberacaoremotaconsulta = useSelector(
    (state) => state.operacaoliberacaoremotaconsulta
  );

  const datahorainicial = useMemo(
    () =>
      format(
        setSeconds(setMinutes(setHours(new Date(), 0), 0), 0),
        'dd/MM/yyyy HH:mm:ss'
      ),
    []
  );

  const datahorafinal = useMemo(
    () =>
      format(
        setSeconds(setMinutes(setHours(new Date(), 23), 59), 59),
        'dd/MM/yyyy HH:mm:ss'
      ),
    []
  );

  const header = useMemo(
    () => [
      {
        id: 'veic_placa_apresentacao',
        label: 'Veículo',
        filter: {
          type: 'text',
        },
        align: 'left',
      },
      {
        id: 'lire_codigo1',
        label: 'Codigo 1',
        align: 'left',
        formatted: (value) => FormatarCodigoLiberacao(value),
      },
      {
        id: 'lire_codigo2',
        label: 'Codigo 2',
        align: 'left',
        formatted: (value) => FormatarCodigoLiberacao(value),
      },
      {
        id: 'bico_numero',
        label: 'Cód. Bico',
        align: 'left',
      },
      {
        id: 'bico_descricao',
        label: 'Bico',
        align: 'left',
      },
      {
        id: 'poco_codigo',
        label: 'Cód. Posto',
        align: 'left',
      },
      {
        id: 'poco_descricao',
        label: 'Posto',
        align: 'left',
      },
      {
        id: 'cond_cpf',
        label: 'Cód.Condutor',
        align: 'left',
      },

      {
        id: 'cond_nome',
        label: 'Condutor',
        align: 'left',
      },
      {
        id: 'usua_login',
        label: 'Login',
        align: 'left',
      },
      {
        id: 'usua_nome',
        label: 'Usuario',
        align: 'left',
      },
      {
        id: 'veic_totalizador',
        label: 'Totalizador',
        align: 'right',
        formatted: (value) => number(value, 1),
      },
      {
        id: 'imab_codigo',
        label: 'Cód. Impedimento',
        align: 'left',
      },
      {
        id: 'lire_status',
        label: 'Status',
        align: 'left',
      },
    ],
    []
  );

  const filter = useMemo(
    () => [
      {
        id: 'data_cadastro_ini',
        label: ' Inicial',
        type: 'initialdatetime',
        defaultValue: datahorainicial,
      },
      {
        id: 'data_cadastro_fim',
        label: 'Final',
        type: 'finaldatetime',
        defaultValue: datahorafinal,
      },
    ],
    [datahorainicial, datahorafinal]
  );

  return (
    <>
      <UnidataTable
        pdf
        excel
        reportOrder="lire_data ASC"
        title={'Liberação Remota - Consulta'}
        create={false}
        delete={false}
        update={false}
        fixed
        header={header}
        custom={filter}
        redux={operacaoliberacaoremotaconsulta}
        read={recordFiltering}
        detach="poco_descricao"
        keys={['lire_codigo1', 'lire_codigo2', 'poco_codigo']}
        view="vw_liberacao_remota"
        reportTitle="Consulta Liberação Remota"
      />
    </>
  );
}

export default OperacaoLiberacaoRemotaConsultaList;
